import React from 'react';
import { 
    Create, 
    SimpleForm, 
    TextInput, 
    SelectInput,
    BooleanInput,
    required,
    email 
} from 'react-admin';
import { FormToolbar } from "../../common/FormToolbar";

export const BranchCreate = props => {
    return (
        <React.Fragment>
            <Create label="Create Branch" {...props}>
                <SimpleForm toolbar={<FormToolbar {...props} />}>
                    <TextInput 
                        source="branch_code" 
                        label='Branch Code' 
                        fullWidth={true} 
                        validate={[required()]} 
                        helperText="Unique code for the branch (e.g., AJMER_MAIN)"
                    />
                    <TextInput 
                        source="branch_name" 
                        label='Branch Name' 
                        fullWidth={true} 
                        validate={[required()]} 
                    />
                    <SelectInput 
                        source="city" 
                        label="City" 
                        choices={[
                            { id: 'AJMER', name: 'Ajmer' },
                            { id: 'BHILWARA', name: 'Bhilwara' },
                            { id: 'BEAWAR', name: 'Beawar' },
                            { id: 'PARBATSAR', name: 'Parbatsar' },
                        ]} 
                        validate={[required()]} 
                    />
                    <TextInput 
                        source="address" 
                        label='Address' 
                        fullWidth={true} 
                        multiline 
                        rows={3}
                    />
                    <TextInput 
                        source="mobile_number" 
                        label='Contact Phone' 
                        fullWidth={true} 
                    />
                    <TextInput 
                        source="email" 
                        label='Contact Email' 
                        fullWidth={true} 
                        validate={[email()]}
                    />
                    <BooleanInput 
                        source="is_active" 
                        label="Active" 
                        defaultValue={true}
                    />
                </SimpleForm>
            </Create>
        </React.Fragment>
    );
}
